import { Action } from '@ngrx/store';
import { ICompany } from '../../../../commons';

export enum CompanyActionTypes {
  LoadCompanyState = '[Company] Load Company State',
  LoadCompanyStateSuccess = '[Company] Load Company State Success',
  LoadCompanyStateFail = '[Company] Load Company State Fail',
  CompanyScreenErrorReset = '[Company] Company Screen Error Reset'

}

export class LoadCompanyState implements Action {
  readonly type = CompanyActionTypes.LoadCompanyState;
}

export class LoadCompanyStateSuccess implements Action {
  readonly type = CompanyActionTypes.LoadCompanyStateSuccess;
  constructor(public payload: ICompany ) {}
}

export class LoadCompanyStateFail implements Action {
  readonly type = CompanyActionTypes.LoadCompanyStateFail;
  constructor(public payload: any) {}
}

export class CompanyScreenErrorReset implements Action {
  readonly type = CompanyActionTypes.CompanyScreenErrorReset;
}

export type CompanyActions = 
  LoadCompanyState
  | LoadCompanyStateSuccess
  | LoadCompanyStateFail
  | CompanyScreenErrorReset;